import { POST, GET } from '@/utils/request'
import Api from './url'

export const activeDetail = async (params: object) => {
  return await GET({
    url: Api.activeDetail,
    params,
    showError: false
  })
}

export const ruleDetail = async (params: object) => {
  return await GET({
    url: Api.ruleDetail,
    params,
    showError: false
  })
}
